var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"progress-container"},[_c('div',{staticClass:"progress-inner",style:({ width: `${_vm.ratio * 100}%` })})])
}
var staticRenderFns = []

export { render, staticRenderFns }